import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import OekonomiskRaadgivning from './pages/OekonomiskRaadgivning';
import JuridiskRaadgivning from './pages/JuridiskRaadgivning';
import Interim from './pages/Interim';
import FullService from './pages/FullService';
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ydelser" element={<Services />} />
            <Route path="/oekonomisk-raadgivning" element={<OekonomiskRaadgivning />} />
            <Route path="/juridisk-raadgivning" element={<JuridiskRaadgivning />} />
            <Route path="/interim-opgaver" element={<Interim />} />
            <Route path="/full-service" element={<FullService />} />
            <Route path="/om-finanju" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
